<template>
  <!-- Google Captcha  -->
  <div class="modal fade custom-modal verify-modal" id="fac-cap">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content Set-google-capt">
        <div class="captcha-header d-flex align-items-center justify-content-between">
          <h4>Facebook Login Settings</h4>
          <span>
            <a href="">
              <i class="feather-x"></i>
            </a>
          </span>
        </div>
        <div class="modaled-body">
          <form action="#">
            <label>Consumer Key (API Key) <span> * </span></label>
            <input type="text" class="form-control fac-key" />
            <p class="fac-goo">
              If you are not sure what is your APP ID, Please head over to
              <span> Getting Started. </span>
            </p>
            <label>Consumer Secret (Secret Key) <span> * </span></label>
            <input type="text" class="form-control" />
          </form>
        </div>
        <div class="acc-submited">
          <a href="" class="btn btn-primary">Save Changes</a>
          <a href="" class="btn btn-secondary">Cancel</a>
        </div>
      </div>
    </div>
  </div>
  <!-- /Google Captcha  -->

  <!-- Agora Captcha  -->
  <div class="modal fade custom-modal verify-modal" id="goo-cap">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content Set-google-capt">
        <div class="captcha-header d-flex align-items-center justify-content-between">
          <h4>Google Login Settings</h4>
          <span>
            <a href="">
              <i class="feather-x"></i>
            </a>
          </span>
        </div>
        <div class="modaled-body">
          <form action="#">
            <label>Client ID <span> * </span></label>
            <input type="text" class="form-control fac-key" />
            <p class="fac-goo">
              If you are not sure what is your APP ID, Please head over to
              <span>Getting Started.</span>
            </p>
            <label>Consumer Secret (Secret Key) <span> * </span></label>
            <input type="text" class="form-control" />
            <label>Login Redirect URL <span> * </span></label>
            <input type="text" class="form-control" />
          </form>
        </div>
        <div class="acc-submited">
          <a href="" class="btn btn-primary">Save Changes</a>
          <a href="" class="btn btn-secondary">Cancel</a>
        </div>
      </div>
    </div>
  </div>
  <!-- /Agora Captcha  -->

  <!-- Agora Captcha  -->
  <div class="modal fade custom-modal verify-modal" id="app-cap">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content Set-google-capt">
        <div class="captcha-header d-flex align-items-center justify-content-between">
          <h4>Apple Login Settings</h4>
          <span>
            <a href="">
              <i class="feather-x"></i>
            </a>
          </span>
        </div>
        <div class="modaled-body">
          <form action="#">
            <label>Client ID <span> * </span></label>
            <input type="text" class="form-control fac-key" />
            <p class="fac-goo">
              If you are not sure what is your APP ID, Please head over to
              <span> Getting Started. </span>
            </p>
            <label>Consumer Secret (Secret Key) <span> * </span></label>
            <input type="text" class="form-control" />
            <label>Login Redirect URL <span> * </span></label>
            <input type="text" class="form-control" />
          </form>
        </div>
        <div class="acc-submited">
          <a href="" class="btn btn-primary">Save Changes</a>
          <a href="" class="btn btn-secondary">Cancel</a>
        </div>
      </div>
    </div>
  </div>
  <!-- /Agora Captcha  -->
</template>
